import { Divider, Typography } from '@mui/material';
import { SLICE_NAME } from 'constants/common';
import { DOMAIN_AUTO_LOGIN } from 'constants/sso';
import useLoginSSO from 'hooks/useLoginSSO';
import { OtherLogin } from 'layouts';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import { getAccessToken } from 'utils/cookies';
import { getAutoLogin, validateDomain } from 'utils/helpers';
import apiManagerUser from '../../../api/manager-users';
import ios from '../../../assets/img/app-store-badge.png';
import android from '../../../assets/img/google-play-badge.png';
import QR from '../../../assets/img/qr-code-vmp.png';
import { PATH_ROOT, URL_ANDROID, URL_IOS } from '../../../constants/api';
import { updatePathApp } from '../../../store/user/userSlice';
import { endSession as logout, SESSION_STATUS } from '../../../store/sessionSlice';
import useViettelCloudIAM from '../useViettelCloudIAM';
import LoginSystem from './components/LoginSystem';
import LoginWith2FA from './components/LoginWith2FA';
import { LOGIN_STEP } from './constant';
import './styles.css';
import DialogLoginSSO from 'pages/manager-meeting/components/DialogLoginSSO';
import { selectCurrentUserPath, selectSessionStatus } from 'store/selectors';

export default function Login() {
    const urlApp = '';
    const [, setGlobalVariable] = useOutletContext();
    const pathApp = useSelector(selectCurrentUserPath);
    const sessionStatus = useSelector(selectSessionStatus);
    const dispatch = useDispatch();
    const iosDownloadLink = URL_IOS;
    const androidDownloadLink = URL_ANDROID;
    const [params] = useSearchParams();
    const autoLogin = getAutoLogin(params.get('autoLogin'));
    const autoLoginStarted = useRef(false);
    const { login: loginViettelCloud } = useViettelCloudIAM();
    const { currentStep } = useSelector((state) => state[SLICE_NAME.LOGIN]);
    const { loginSSOGoogle } = useLoginSSO();
    const domain = validateDomain(params.get('domain'));
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { search } = useLocation();
    const configHiddenTabbar = new URLSearchParams(search).get("hiddenTabBar") || window.localStorage.getItem("hiddenTabBar")

    const hiddenTabBar = configHiddenTabbar === "true"

    const toPageDownload = (url) => {
        window.location = url;
    };

    const getLoginInfo = () => {
        return apiManagerUser.getLoginInfo();
    };

    useEffect(() => {
        if (autoLogin && !autoLoginStarted.current) {
            autoLoginStarted.current = true;
            switch (autoLogin) {
                case DOMAIN_AUTO_LOGIN.VIETTEL_CLOUD:
                    loginViettelCloud();
                    break;
                case DOMAIN_AUTO_LOGIN.GOOGLE:
                    loginViettelCloud();
                    break;
                case DOMAIN_AUTO_LOGIN.SME:
                    loginSSOGoogle();
                    break;
                default:
                    break;
            }
            localStorage.setItem('checkEventPopupByUser', 1);
        }
    }, [autoLogin, loginViettelCloud, loginSSOGoogle]);

    /**
     * Điều hướng người dùng
     */
    useEffect(() => {
        window.localStorage.setItem("hiddenTabBar", JSON.stringify(hiddenTabBar));
    }, [hiddenTabBar])

    useEffect(() => {
        if (sessionStatus !== SESSION_STATUS.AUTHENTICATED) return;

        const accessToken = getAccessToken();
        if (!accessToken) {
            dispatch(logout());
            return;
        }

        const redirectAuthenticatedUser = async () => {
            if (domain) {
                try {
                    const response = await getLoginInfo();
                    if (response.status !== 200) throw new Error('Invalid session');
                    localStorage.setItem('checkEventPopupByUser', 1);
                    window.location.href = `${domain}?token=${accessToken}`;
                    return;
                } catch (error) {
                    dispatch(logout());
                    localStorage.setItem('checkEventPopupByUser', 0);
                    return;
                }
            }

            localStorage.setItem('checkEventPopupByUser', 1);
            setGlobalVariable(prev => ({ ...prev, isRedirectFromLogin: true }));
            navigate(pathApp || `${PATH_ROOT}/`);
            dispatch(updatePathApp(''));
        };

        redirectAuthenticatedUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionStatus, domain])

    return (
        <div className="form-login-container">
            <DialogLoginSSO />
            <div className="form-login-body">
                <Typography className="title title-login">{t('auth.login')}</Typography>
                <div className="form-login">
                    {currentStep === LOGIN_STEP.SYSTEM && <LoginSystem />}
                    {currentStep === LOGIN_STEP.ENTER_2FA && <LoginWith2FA />}
                </div>
                <OtherLogin isLogin={true} />
                <div className="no-account">
                    <Divider>
                        <Typography px={2} color={theme => theme.palette.text.secondary}>{t('auth.ortherLogin')}</Typography>
                    </Divider>
                    <div className="icon-sso">
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <a href={androidDownloadLink}>
                                <img
                                    alt="android"
                                    src={android}
                                    width="140px"
                                    height="35px"
                                    style={{ cursor: 'pointer', width: { xl: '160px', lg: '140px' } }}
                                />
                            </a>
                            <a rel="noopener noreferrer" target="_blank" href={iosDownloadLink}>
                                <img alt="ios" src={ios} width="140px" height="35px" style={{ cursor: 'pointer' }} />
                            </a>
                        </div>
                        <img
                            alt="qr"
                            src={QR}
                            width="70"
                            height="70.97"
                            style={{ marginLeft: '14px' }}
                            onClick={() => {
                                if (urlApp !== '' && urlApp) {
                                    toPageDownload(urlApp);
                                }
                            }}
                        ></img>
                    </div>
                </div>
            </div>
        </div>
    );
}
